// Screen `recording-notice` (owner: meeting-recorder, owner feedback F15): what a guest of a meeting is told about
// the notetaker, and "Do not record me". The long random address is the only credential.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicNoticePage } from '../../../features/recorder/PublicNoticePage';

export const Route = createFileRoute('/_public/recording/$token')({
  validateSearch: z.object({ lang: z.enum(['en', 'de']).optional().catch(undefined) }),
  head: () => ({
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'referrer', content: 'no-referrer' },
    ],
  }),
  component: function RecordingNoticeRoute() {
    const { token } = Route.useParams();
    return <PublicNoticePage token={token} lang={Route.useSearch().lang} />;
  },
});
